import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogsComponent } from './catalogs.component';
import { CatalogsRoutingModule } from './catalogs-routing.module';
import { CatalogService } from './catalogs.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [CatalogsRoutingModule, CommonModule, SharedModule],
  declarations: [CatalogsComponent],
  exports: [CatalogsComponent],
  providers: [CatalogService]
})
export class CatalogsModule { }
